import React, { Component } from 'react';
import './Loading.css';

class Loading extends Component {
  render() {
    return (
      <p id="loadingAll">
        Loading...
      </p>
    );
  }
}

export default Loading;
